import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowRight, Check } from "lucide-react";

export default function CheckoutSuccess() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        {/* Success Icon */}
        <div className="w-16 h-16 rounded-full bg-[#6B8E7C] flex items-center justify-center mx-auto mb-8">
          <Check className="w-8 h-8 text-white" />
        </div>

        <h1 className="text-3xl md:text-4xl mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          Welcome to Calm Scale™
        </h1>
        
        <p className="text-[#6B8E7C] font-medium mb-8">
          You've chosen structure.
        </p>

        <div className="text-left bg-white border border-[#E5E0D6] rounded-xl p-6 mb-10">
          <p className="text-sm text-[#2C2C2C]/50 uppercase tracking-wide mb-4">
            Here's what happens next:
          </p>
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 rounded-full bg-[#F2F0EB] flex items-center justify-center flex-shrink-0 text-xs text-[#2C2C2C]/60">1</span>
              <span className="text-[#2C2C2C]/70">Check your email for payment confirmation.</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 rounded-full bg-[#F2F0EB] flex items-center justify-center flex-shrink-0 text-xs text-[#2C2C2C]/60">2</span>
              <span className="text-[#2C2C2C]/70">Access your dashboard below.</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 rounded-full bg-[#F2F0EB] flex items-center justify-center flex-shrink-0 text-xs text-[#2C2C2C]/60">3</span>
              <span className="text-[#2C2C2C]/70">Begin with Phase One: Clarity.</span>
            </li>
          </ul>
        </div>

        <Link to="/login">
          <Button 
            className="btn-primary text-base px-10 py-4"
            data-testid="access-dashboard-btn"
          >
            Access My 14-Day Build
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </Link>

        <p className="text-xs text-[#2C2C2C]/40 mt-8">
          If you need assistance, contact: support@calmscale.com
        </p>
      </div>
    </div>
  );
}
